import { render } from "./DemoSection.vue?vue&type=template&id=67af5f3c&scoped=true"
import script from "./DemoSection.vue?vue&type=script&lang=js"
export * from "./DemoSection.vue?vue&type=script&lang=js"

import "./DemoSection.vue?vue&type=style&index=0&id=67af5f3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67af5f3c"]])

export default __exports__